const AuthActionTypes = {
    SET_LOGGED_IN : "SET_LOGGED_IN",
    SET_LOGGED_OUT: "SET_LOGGED_OUT"
};

export default AuthActionTypes;